import { withTheme } from 'styled-components';
import { Icon } from '../IconStyled';

export const SuccessIcon = ({
  color = 'iconAction_4',
  theme,
  isFloating = false,
  height = '16',
  width = '16',
}) => (
  <Icon isFloating={isFloating}>
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="success-icon"
    >
      <circle cx="8" cy="8" r="8" fill={theme[color] || theme.iconAction_4} />
      <path d="M3 8.07692L6.84615 11.1538L13 5" stroke="white" />
    </svg>
  </Icon>
);

export default withTheme(SuccessIcon);
